var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('ckeditor',{attrs:{"config":_vm.config,"upload-adapter":_vm.uploadAdapter,"type":"classic"},model:{value:(_vm.html),callback:function ($$v) {_vm.html=$$v},expression:"html"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }